import { TOP_ROUTES, PAGE_ROUTES } from './routes';
import { pageKey } from './pageConstants';

export const ASHCareSubdomain = () => {
	const { origin } = window.location;
	if (origin.includes('localhost') || origin.includes('dev')) {
		return 'dev.';
	}
	if (origin.includes('stg')) {
		return 'stg.';
	}
	if (origin.includes('tst')) {
		return 'tst.';
	}
	return '';
};

export const HOME_URL = `/ASH/default.aspx`;
// when testing this locally, the user will be signed out of the dev clinical ashlink site
export const LOGOUT_URL = `/ASH/site/authentication/SessionLogout.aspx`;
export const ASHCARE_URL = `//${ASHCareSubdomain()}portal.ashcare.com/landing`;

const FAQ_PATH = `/${TOP_ROUTES.help}/${PAGE_ROUTES.faq}`;

export const MESSAGE_CENTER = {
	key: pageKey.messageCenter,
	label: 'Message Center',
};

export const MY_ACCOUNT_PROFILE_NAV_ITEMS = [
	{
		key: pageKey.accountManagement,
		path: `/${TOP_ROUTES.account}/${PAGE_ROUTES.accountManagement}`,
		label: 'Account Management',
		order: 1,
	},
	{
		key: pageKey.manageSubAccounts,
		path: `/${TOP_ROUTES.account}/${PAGE_ROUTES.manageSubAccounts}`,
		label: 'Manage Sub Accounts',
		order: 2,
	},
	{
		key: pageKey.transactionSummary,
		label: 'Transaction Summary',
		order: 3,
	},
	{
		key: pageKey.practitionerStatusChangeRequest,
		label: 'Practitioner Status Change Request',
		order: 4,
	},
	{
		key: pageKey.confirmUpdateInformation,
		label: 'Confirm/Update Your Information',
		order: 5,
	},
	{
		key: pageKey.favoriteCPTCode,
		label: 'Favorite CPT Codes',
		order: 6,
	},
];

export const FOOTER_ITEMS = [
	{
		key: pageKey.contactUs,
		label: 'Contact Us',
		newTab: false,
	},
	{
		key: pageKey.privacyStatement,
		label: 'Privacy Statement',
		newTab: true,
		path: TOP_ROUTES.privacyStatement,
	},
	{
		key: pageKey.termsAndCondition,
		label: 'Terms & Conditions',
		newTab: true,
		path: TOP_ROUTES.termsAndConditions,
	},
	{
		key: pageKey.frequentlyAskedQuestion,
		label: 'FAQ',
		path: FAQ_PATH,
		newTab: false,
	},
];

export const HELP_NAV_ITEMS = [
	{
		key: pageKey.ASHLinkWebsiteTip,
		label: 'ASHLink Website Tips',
		order: 1,
	},
	{
		key: pageKey.frequentlyAskedQuestion,
		label: 'FAQ',
		path: `/${TOP_ROUTES.help}/${PAGE_ROUTES.faq}`,
		order: 2,
	},
	{
		key: pageKey.submitAnOnlineQuestionOrComment,
		label: 'Submit an online question or comment',
		order: 3,
	},
];

export const RESOURCES_NAV_ITEMS = [
	{
		key: pageKey.clientSummary,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.clientSummaries}`,
		label: 'Client Summaries',
		order: 1,
	},
	{
		key: pageKey.CPSAnnualReview,
		label: 'CPS Annual Review/Tier Assignment Letter',
		order: 2,
	},
	{
		key: pageKey.resourcesForm,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.forms}`,
		label: 'Forms',
		order: 3,
	},
	{
		key: pageKey.newsletter,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.newsletters}`,
		label: 'Newsletters',
		order: 4,
	},
	{
		key: pageKey.notification,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.notifications}`,
		label: 'Notifications',
		order: 5,
	},
	{
		key: pageKey.operationsManual,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.operationsManual}`,
		label: 'Operations Manuals',
		order: 6,
	},
	{
		key: pageKey.practitionerEducationLibrary,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.practitionerEducationLibrary}`,
		label: 'Practitioner Education Library',
		order: 7,
	},
	{
		key: pageKey.practitionerServiceAgreement,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.practitionerServiceAgreements}`,
		label: 'Practitioner Services Agreements',
		order: 8,
	},
	{
		key: pageKey.providerEducationLibrary,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.providerEducationLibrary}`,
		label: 'Provider Education Library',
		order: 9,
	},
	{
		key: pageKey.providerServiceAgreement,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.providerServiceAgreements}`,
		label: 'Provider Services Agreements',
		order: 10,
	},
	{
		key: pageKey.valueAddedProgram,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.valueAddedProgram}`,
		label: 'Value Added Programs',
		order: 11,
	},
	{
		key: pageKey.providerPractitionerVirtualServicesAgreement,
		path: `/${TOP_ROUTES.resources}/${PAGE_ROUTES.providerPractitionerVirtualServicesAgreement}`,
		label: 'Provider Services / Practitioner Virtual Service Agreement',
		order: 12,
	},
];

export const BATCH_CLAIMS_NAV_ITEMS = [
	{
		key: pageKey.ASHClearinghouse,
		label: 'ASH Clearinghouse',
		order: 1,
	},
	{
		key: pageKey.batchClaimsSummary,
		label: 'Batch Claims Summary',
		order: 2,
	},
	{
		key: pageKey.batchClaimsUpload,
		label: 'Batch Claims Upload',
		order: 3,
	},
];

export const TOP_SEARCH_NAV_ITEMS = [
	{
		key: pageKey.newPatientSearch,
		label: 'New Patient',
		order: 1,
	},
	{
		key: pageKey.existingPatientSearch,
		label: 'Existing Patient',
		order: 2,
	},
	{
		key: pageKey.claimsSearch,
		label: 'Claims',
		order: 3,
	},
	{
		key: pageKey.paymentsSearch,
		label: 'Payments',
		order: 4,
	},
	{
		key: pageKey.remittanceAdviceSearch,
		label: 'Remittance Advice',
		order: 5,
	},
	{
		key: pageKey.MNRFormSearch,
		label: 'MNR Form',
		order: 6,
	},
	{
		key: pageKey.reopenModificationsSearch,
		label: 'Reopen/Modifications',
		order: 7,
	},
];

export const TOP_NAV_ITEMS = [
	{
		key: 'home',
		label: 'Home',
		isDropdown: false,
		order: 1,
	},
	{
		key: 'search',
		label: 'Search',
		isDropdown: true,
		menuItems: TOP_SEARCH_NAV_ITEMS,
		order: 2,
	},
	{
		key: 'member-referral',
		label: 'Referrals',
		isDropdown: false,
		order: 3,
	},
	{
		key: 'resources',
		label: 'Resources',
		isDropdown: true,
		menuItems: RESOURCES_NAV_ITEMS,
		order: 4,
	},
	{
		key: 'batch-claims',
		label: 'Batch Claims',
		isDropdown: true,
		menuItems: BATCH_CLAIMS_NAV_ITEMS,
		order: 5,
	},
	{
		key: 'compliance',
		label: 'Compliance',
		isDropdown: false,
		path: TOP_ROUTES.compliance,
		order: 6,
	},
	{
		key: 'help',
		label: 'Help',
		isDropdown: true,
		menuItems: HELP_NAV_ITEMS,
		order: 7,
	},
	{
		key: 'ashcare',
		label: 'ASHCare',
		isDropdown: false,
		isLegacy: true,
		path: ASHCARE_URL,
		isExternal: true,
		order: 8,
	},
];
